import styled from "styled-components";

import BaseDivider from "../Divider";

export const Divider = styled(BaseDivider)(() => ({
  width: "100%",
}));
